import React from 'react';

import './icon-toggle.scss';

interface IconToggleProps {
  ariaLabelledBy: string;
  icon: React.ReactElement;
  isEnabled: boolean;
  label: React.ReactElement;
  onToggle: () => void;
}

function IconToggle(props: IconToggleProps): React.ReactElement {
  const { ariaLabelledBy, icon, isEnabled, label, onToggle } = props;

  return (
    <label
      aria-labelledby={ariaLabelledBy}
      className="icon-toggle"
      styleName="container"
    >
      <input onChange={onToggle} styleName="input" type="checkbox" />
      <div
        className="icon-toggle__indicator"
        styleName={`indicator ${isEnabled ? 'indicator--checked' : ''}`}
      >
        <div styleName="circle">{icon}</div>
      </div>
      {label}
    </label>
  );
}

export default IconToggle;
